import moment from 'moment';

import { SMART_FILTER_TYPES } from '../../constants';
import createOption from './option-mapper';

/**
 * Gets query params based on applied filters
 * @param {object[]} filters - Applied filters
 * @return {object} - Filter Params Object
 */
export const getFilterParams = (filters) => ({
  ...filters,
  smartFilter: undefined,
  VisibilityAppStatus: filters?.VisibilityAppStatus?.value,
  Status: filters?.Status?.value,
  Problem: filters?.Problems?.value,
  OriginPickupDate: filters?.OriginPickupDate
    && moment(filters?.OriginPickupDate).format('YYYY-MM-DD'),
  DestinationDropOffDate: filters?.DestinationDropOffDate
    && moment(filters?.DestinationDropOffDate).format('YYYY-MM-DD'),
  LastHumanTrackDate: filters?.LastHumanTrackDate
    && moment(filters?.LastHumanTrackDate).format('YYYY-MM-DD'),
  LoadsWithProblems: (filters?.smartFilter === SMART_FILTER_TYPES.loadsWithProblems) || undefined,
  LateLoads: (filters?.smartFilter === SMART_FILTER_TYPES.lateLoads) || undefined,
  WithinTwoHours: (filters?.smartFilter === SMART_FILTER_TYPES.withinTwoHours) || undefined,
  OriginCity: filters?.OriginCity?.value,
  OriginState: filters?.OriginState?.value,
  DestinationCity: filters?.DestinationCity?.value,
  DestinationState: filters?.DestinationState?.value,
  CarrierName: filters?.CarrierName?.value,
  CarrierRepName: filters?.CarrierRepName?.value,
  CustomerName: filters?.CustomerName?.value,
  Shipper: filters?.Shipper?.value,
  Consignee: filters?.Consignee?.value,
  SalesRep: filters?.SalesRep?.value,
});

/**
 * Updates URL searchParams
 * @param {object} searchParams - Current URL search params
 * @param {*} updatedParams - Updated URl search params
 * @return {string} - Updates searchparams
 */
export const updateQueryString = (searchParams, updatedParams) => {
  Object.entries(updatedParams).forEach(([name, value]) => {
    if (value) {
      if (typeof value === 'object') {
        searchParams.set(name, value.label);
      } else {
        searchParams.set(name, value);
      }
    } else {
      searchParams.delete(name);
    }
  });
  return searchParams.toString();
};

/**
 * Gets filter state based off URL search params
 * @param {object} searchParams - Current URL search Params
 * @return {object[]} - Array of active filters
 */
export const getFilterStateFromQueryParams = (searchParams) => {
  const activeFilters = { smartFilter: SMART_FILTER_TYPES.lateLoads };
  searchParams.forEach((value, name) => {
    switch (name) {
      case 'searchTerm':
      case 'sortBy':
      case 'sortDir':
        break;
      case 'VisibilityAppStatus':
      case 'Status':
      case 'OriginCity':
      case 'OriginState':
      case 'DestinationCity':
      case 'DestinationState':
      case 'CarrierRepName':
      case 'CustomerName':
      case 'CarrierName':
      case 'Problems':
        activeFilters[name] = createOption(value);
        break;
      case 'OriginPickupDate':
      case 'DestinationDropOffDate':
      case 'LastHumanTrackDate':
        activeFilters[name] = moment(value).toDate();
        break;
      default:
        activeFilters[name] = value;
    }
  });
  return activeFilters;
};
